<template>
  <b-card class="w-100 pt-0 pb-0 border-0">
    <b-tabs content-class="pt-3 text-muted" nav-class="nav-tabs-custom">
      <b-tab :active="true">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="far fa-user"></i>
          </span>
          <span class="d-none d-sm-inline-block">Rent History</span>
        </template>
        <div class="row">
          <div class="col-sm-4 col-md-4 col-12">
            <div class="p-3 history-box">
              <div class="ts-16 fw-700 mb-3">History Overview</div>
              <div class="ts-14 fw-600 d-flex justify-content-between">
                <div>Joined In:</div>
                <div>{{ joinedInFormat() }}</div>
              </div>
              <hr />
              <div class="ts-14 fw-600 d-flex justify-content-between">
                <div>Total Space Posted:</div>
                <div>{{ businessDetails.spacedPosted }}</div>
              </div>
              <hr />
              <div class="ts-14 fw-600 d-flex justify-content-between">
                <div>Total Renters:</div>
                <div>{{ businessHistory.totaRents }}</div>
              </div>
            </div>
          </div>
          <div class="col-sm-8 col-md-8 col-12">
            <div class="g-0 text-center" v-if="businessHistory.history.length == 0 || true">
              <p class="m-0" style="font-size: 50px">
                <i class="bx bx-history"></i>
              </p>
              <span>No store history</span>
            </div>
            <template v-else>
              <div
                class="card bg-light text-dark border-0"
                :key="index"
                v-for="(item, index) in businessHistory"
              >
                <div class="card-body row">
                  <div class="col-1">
                    <img
                      :src="item['image']"
                      class="rounded-circle"
                      height="50"
                      @error="
                        (e) =>
                          (e.target.src = require('@/assets/images/img-placeholder.png'))
                      "
                    />
                  </div>
                  <div class="col-11">
                    <p class="m-0 ts-18">{{ item["name"] }}</p>
                    <p class="m-0 ts-13">
                      <span><b>Rented:</b> {{ item["rent_duration"] }}</span>
                      <span class="float-end">
                        <b>Started:</b> {{ item["started_at"] | formatDate }} -
                        <b>Ended:</b> {{ item["ended_at"] | formatDate }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <!--end of card-->
            </template>

            <div
              class="row g-0 text-center text-sm-start"
              v-if="businessHistory.history.length > 0 && false"
            >
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div
                      class="dataTables_paginate paging_simple_numbers float-end"
                    >
                      <!-- pagination -->
                      <b-pagination
                        class="pagination-rounded"
                        v-model="historyPaginate.page"
                        @input="rentHistoryPaginate"
                        :total-rows="10"
                        :per-page="historyPaginate.rows"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!--end of pagination-->
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </b-card>
</template>

<script>
import { listingComputed, listingMethods } from "@/state/helpers";
import moment from "moment";

export default {
  props: ["value"],
  data() {
    return {
      selectedItem: [],
      historyPaginate: {
        page: 1,
        rows: 4,
      },
    };
  },
  computed: {
    ...listingComputed,
  },
  methods: {
    ...listingMethods,
    rentHistoryPaginate() {
      console.log(this.historyPaginate);
    },
    joinedInFormat() {
      try {
        return moment(this.businessDetails.joinedIn).format("MMMM YYYY"); 
      } catch (error) {
        console.log(error);
        return null;
      }
    },
  },
};
</script>

<style>
.rent-history-title {
  color: #000;
  font-weight: bold;
  font-size: 16px;
}

.history-box {
  border-radius: 8px;
  border: solid 1px #E1E1E1;
  color: #000;
}
</style>

